export const portfolioData = [
  {
    id: 1,
    name: "Pandora",
    languages: ["html", "css", "javascript"],
    languagesIcons: ["fab fa-html5", "fab fa-css3-alt", "fab fa-js"],
    source: "https://pandoratheme.netlify.app/",
    info: "Premier projet créé pendant ma formation à la Wild Code School",
    picture: "./media/pandora.png",
  },
  {
    id: 2,
    name: "Prev33.fr",
    languages: [
      "html",
      "css",
      "javascript",
      "react",
      "node js",
      "express js",
      "mysql",
    ],
    languagesIcons: [
      "fab fa-html5",
      "fab fa-css3-alt",
      "fab fa-js",
      "fab fa-react",
      "fab fa-node-js",
    ],
    source: "http://www.prev33.fr",
    info: "Refonte du site Prev33, dernier projet ",
    picture: "./media/prev33.png",
  },
  {
    id: 3,
    name: "RisQ",
    languages: ["javascript", "react", "css"],
    languagesIcons: [
      "fab fa-html5",
      "fab fa-css3-alt",
      "fab fa-js",
      "fab fa-react",
      "fab fa-node-js",
    ],
    source: "https://github.com/sam-rached/hackathon",
    info: "Hackathon de décembre 2021 pour le compte d'Enedis et la sécurité",
    picture: "./media/RisQ.png",
  },
  {
    id: 4,
    name: "Portfolio SamR",
    languages: ["html", "css", "javascript"],
    languagesIcons: ["fab fa-html5", "fab fa-css3-alt", "fab fa-js"],
    source: "https://samirached.com",
    info: "Un portfolio développé en HTML, CCS et javascript, une autre manière de se présenter 🙂",
    picture: "./media/Portfolio_SamR.jpg",
  },
  {
    id: 5,
    name: "Marvel Quiz",
    languages: ["react", "javascript", "css"],
    languagesIcons: ["fab fa-react", "fab fa-js", "fab fa-css3-alt"],
    source: "https://marvel-quiz-ef6c3.web.app/",
    info: "Application proposée par DonkeyGeek dans sa formation 'React JS pour tous (+ 45 heures)' sur Udemy que j'ai codé, avec React V18, React-router-dom V6 pour le front-end et Firebase pour le back-end ",
    picture: "./media/Marvel_Quiz.jpg",
  },
  {
    id: 6,
    name: "test.io",
    languages: ["react", "css", "php"],
    languagesIcons: [
      "fab fa-react",
      "fab fa-css3-alt",
      "fab fa-php",
    ],
    source: "http://www.github.com",
    info: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium, veritatis debitis odio eveniet quos incidunt eaque nemo eius perferendis consequatur? Lorem ipsum, dolor sit amet consectetur adipisicing elit. Accusamus laboriosam aut nihil? Possimus, id facilis dignissimos repudiandae modi dolorum ea accusantium.",
    picture: "./media/project6.JPG",
  },
];